import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import UserService from '../../services/UserService';
import LoadConfigurationCodeService from '../../services/LoadConfigurationCodeService';
import LoadConfigurationService from '../../services/LoadConfigurationService';
import {
    changeRoom, initializeSections, initializeSummaryCameras, setPromotionSlug, setPublic,
} from '../../model/configuratorSlice';
import SetPassword from '../User/SetPassword';
import Login from '../User/Login';
import { ApplicationState } from '../../model/constants';
import PromotionStatusPopup from '../PromotionStatusPopup/PromotionStatusPopup';
import MainLoader from '../Loader/MainLoader';
import Configurator from './Configurator';
import IsNullOrUndefined from '../../utils/ObjectUtils';
import UnitSelector from '../UnitSelector/UnitSelector';
import UserStatusPopup from '../User/UserStatusPopup';
import LoadPublicConfigurationService from '../../services/LoadPublicConfigurationService';

const ConfiguratorGuard = () => {
    const { promotionSlug, code } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const { applicationState, rooms } = useSelector(state => state.configurator);
    const userMutation = UserService();
    const loadConfigurationCodeMutation = LoadConfigurationCodeService();
    const loadConfigurationMutation = LoadConfigurationService();
    const loadPublicConfigurationMutation = LoadPublicConfigurationService();

    const dispatch = useDispatch();

    dispatch(setPromotionSlug(promotionSlug));

    useEffect(() => {
        const payload = {};
        const habitatToken = searchParams.get('t');
        const loginToken = searchParams.get('login-token');
        const resetPasswordToken = searchParams.get('reset-password-token');

        if (code !== 'public') {
            if (!IsNullOrUndefined(loginToken)) payload.login_token = loginToken;
            if (!IsNullOrUndefined(resetPasswordToken)) payload.reset_password_token = resetPasswordToken;
            if (!IsNullOrUndefined(habitatToken)) payload.habitat_token = habitatToken;

            userMutation.mutate(payload);
            setSearchParams();
        } else {
            /// TODO: set variable to mark isPublic link to hide several things across the configurator.
            dispatch(setPromotionSlug(promotionSlug));
            dispatch(setPublic(true));
            loadPublicConfigurationMutation.mutate();
        }
    }, []);

    useEffect(() => {
        console.log(`applicationState: ${applicationState}`);
        switch (applicationState) {
            case ApplicationState.UserLoggedIn:
                loadConfigurationMutation.mutate({});
                break;
            case ApplicationState.UserLoggedOut:
                userMutation.mutate({});
                break;
            case ApplicationState.PromotionLoaded:
                dispatch(changeRoom(rooms[0].id));
                dispatch(initializeSections());
                dispatch(initializeSummaryCameras());

                if (code !== undefined && code !== 'public') {
                    loadConfigurationCodeMutation.mutate(code);
                }
                break;
            default:
                break;
        }
    }, [applicationState]);

    switch (applicationState) {
        case ApplicationState.NotInitialized:
            return <MainLoader />;
        case ApplicationState.RequestBudgetNotStarted:
            return <PromotionStatusPopup />;
        case ApplicationState.UserLoginFailed:
            return <UserStatusPopup />;
        case ApplicationState.UserLoggedOut:
            return <Login />;
        case ApplicationState.UserSetPasswordRequired:
            return <SetPassword />;
        case ApplicationState.UserSelectFromMultipleUnitsRequired:
            return <UnitSelector />;
        case ApplicationState.UserLoggedIn:
            return <MainLoader />;
        case ApplicationState.PromotionLoaded:
            return <Configurator />;
        case ApplicationState.Ready:
            return <Configurator />;
        default:
            return <MainLoader />;
    }
};

export default ConfiguratorGuard;
